import { Controller } from '@hotwired/stimulus'
import Toast from 'libs/toast'

export default class extends Controller {
  toggle(event) {
    const locationField = document.querySelector('[data-field="location"]')
    const latField = document.querySelector('[data-field="lat"]')
    const lngField = document.querySelector('[data-field="lng"]')

    if (!event.target.checked) {
      locationField.value = null
      latField.value = 0
      lngField.value = 0
      return
    }

    navigator.geolocation.getCurrentPosition(
      (position) => {
        const geocoder = new google.maps.Geocoder()
        const location = { lat: position.coords.latitude, lng: position.coords.longitude }

        geocoder.geocode({ location }, (results, status) => {
          if (status !== 'OK') {
            event.target.checked = false
            return
          }

          const place = results[0]
          locationField.value = place.formatted_address
          latField.value = place.geometry.location.lat()
          lngField.value = place.geometry.location.lng()
        })
      },
      () => {
        new Toast(I18n.t('js.geolocation.blocked'), { type: 'alert' }).show()
        event.target.checked = false
      }
    )
  }
}
